import React from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import { Avatar } from '@wartek-id/avatar'
import { Text } from '@wartek-id/text-v1'

type TestimonyCardProps = {
  testimony: string
  imgUrl?: string
  name: string
  schoolName: string
  className?: string
}

const TestimonyCard = ({
  name,
  schoolName,
  testimony,
  imgUrl,
  className,
}: TestimonyCardProps) => {
  return (
    <div
      className={clsx(
        'bg-white p-6 rounded-lg shadow-sm border flex flex-col h-full text-left',
        className
      )}
    >
      <div className="mb-6 flex-grow">
        <Text
          variant="body-sm"
          color="subdued"
          className="italic !leading-relaxed"
        >
          "{testimony}"
        </Text>
      </div>
      <div className="border-t pt-4 flex items-start space-x-4 mt-auto">
        <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
          {imgUrl ? (
            <Image
              alt="user-picture"
              src={imgUrl}
              height={48}
              width={48}
              objectFit="cover"
            />
          ) : (
            <Avatar
              alt="user-picture"
              src={imgUrl}
              name={name}
              shape="circle"
              size="xl"
            />
          )}
        </div>
        <div className="flex-1">
          <Text variant="body-sm-bold">{name}</Text>
          <Text variant="body-sm" color="subdued">
            {schoolName}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default TestimonyCard
